import dayjs, { Dayjs } from "dayjs";
import { PromoDTO } from "../../ProductService/NormasTeachingPromo/useAllPromos.ts";
import { SalesPeriod } from "./salesPeriod.ts";

export type PromotionInPeriod = {
  promo: PromoDTO;
  shortName: string;
  from: Dayjs;
  to: Dayjs;
  appliesToEveryItem: boolean;
};

function appliesToAnyOf(promo: PromoDTO, itemKeys: string[]): boolean {
  const applicableProducts = promo.applicableProducts ?? [];
  return (
    itemKeys.length === 0 ||
    applicableProducts.length === 0 ||
    applicableProducts.some((product) => itemKeys.includes(product.id))
  );
}

export function promotionsShownIn({
  promos,
  period,
  filteredItemKeys,
}: {
  promos: PromoDTO[];
  period: SalesPeriod;
  filteredItemKeys: string[];
}): PromotionInPeriod[] {
  return promos
    .filter((promo) => promo.isActive)
    .filter((promo) => appliesToAnyOf(promo, filteredItemKeys))
    .flatMap((promo) => {
      const validFrom = promo.validFrom ? dayjs(promo.validFrom) : period.from;
      const validTo = promo.validTo ? dayjs(promo.validTo) : period.to;
      const from = validFrom.isAfter(period.from) ? validFrom : period.from;
      const to = validTo.isBefore(period.to) ? validTo : period.to;
      return from.isAfter(to)
        ? []
        : [
            {
              promo,
              from,
              to,
              appliesToEveryItem: (promo.applicableProducts ?? []).length === 0,
            },
          ];
    })
    .sort((first, second) => first.from.valueOf() - second.from.valueOf())
    .map((promotion, index) => ({ ...promotion, shortName: `P${index + 1}` }));
}

export function promotionsActiveOn(
  promotions: PromotionInPeriod[],
  bucket: { start: Dayjs; end: Dayjs },
): PromotionInPeriod[] {
  return promotions.filter(
    (promotion) =>
      !promotion.from.isAfter(bucket.end) &&
      !promotion.to.isBefore(bucket.start),
  );
}
